export default {
  mutations: {
    SET_CREDENTIAL_TYPES_LIST: 'SET_CREDENTIAL_TYPES_LIST',
  },
  getters: {
    GET_CREDENTIAL_TYPES_LIST: 'GET_CREDENTIAL_TYPES_LIST',
  },
  actions: {
    CREDENTIAL_TYPES_LIST: 'CREDENTIAL_TYPES_LIST',
  },
};
